import React                            from "react";
import numeral                          from "numeral";
import classnames                       from 'classnames';

import { isValidPartSupplier }          from "product_tabs/tab_parts/utils/helpers";

const Substitute = (props) => {

  const {
    exact_qty,
    markup,
    selected_board_qty,
    selected_ps,
    substitute,
    onReplacePartSupplier,
  } = props;

  if(!substitute) return null

  const {
    extra_parts,
    mpn,
    selected_part_supplier,
    part_suppliers,
  } = substitute

  const valid_part_suppliers = part_suppliers.filter((ps) => isValidPartSupplier(ps, selected_board_qty))

  const onChange = (e) => {
    const [substitute_id, part_supplier_id] = e.target.value.split("-")
    const ps_to_be_replaced = valid_part_suppliers.find((ps) => ps.id == part_supplier_id)
    onReplacePartSupplier(substitute, ps_to_be_replaced)
  }

  return (
    <>
      {valid_part_suppliers.map((ps, index) => {
        const {selected_pricebreak, description, url: part_supplier_url, supplier, partnumber} = ps
        const {price} = selected_pricebreak[selected_board_qty]
        const unit_price = (price * (1 + markup))
        const checked = `${substitute.id}-${ps.id}` === selected_ps

        return (
          <tr key={`offer-${substitute.id}-${index}`}>
            {index == 0 && 
              <td className={classnames("", { "bg-selection":  selected_ps && selected_ps.split("-")[0] === `${substitute.id}` })}
                rowSpan={valid_part_suppliers.length}>
                {mpn}<br/>
              </td>
            }
            <td className={classnames("", { "bg-selection": checked })}>
              {partnumber}<br/>
              <small>Recommended by {supplier.name}</small>
            </td>
            <td className={classnames("", { "bg-selection": checked })}>
              {description}<br/>
              <a href={part_supplier_url} target="_blank">Check Specifications</a>
            </td>
            <td className={classnames("text-end", { "bg-selection": checked })}>${numeral(unit_price).format('0.0000')}</td>
            <td className={classnames("", { "bg-selection": checked })}>
              <input
                type="radio"
                key={`input-offer-${substitute.id}-${index}`}
                checked={checked}
                value={`${substitute.id}-${ps.id}`}
                name={`offer-${substitute.id}-${index}`}
                className="offer-radio-btn form-check-input"
                onChange={onChange}/>
            </td>
          </tr>
        )
      })}
    </>
  )
}

export default Substitute;